import React, { FC, useState } from 'react'
import config from './config'
import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import { useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'

import Button from '../../../../../components/Atoms/Button/Button'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import { FormProps } from '../../../../Pages/Onboarding/types'
import Info from 'src/components/Atoms/Info/Info'
import Font from 'src/components/Core/Typography/Font/Font'

const IndividualAccountOpeningDocumentationForm: FC<FormProps> = props => {
  const [showInfo, setShowInfo] = useState(true)
  const { dropdownOptions } = useDropdownOptions()

  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    configData
  } = useForm(
    props.fetchedData,
    config({ countries: dropdownOptions.countries }),
    submitForm
  )

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>{t('onboarding.forms.IndividualAccount.AccountOpeningDocumentationForm.title')}</FormTitle>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      {showInfo && (
        <Info closeInfo={() => setShowInfo(false)} margin='20px 0 0 0'>
          <Font>
            {/* @ts-ignore-next-line */}
            <Trans i18nKey='onboarding.forms.CorporateAccount.CompanyDetailsForm.info.content' />
          </Font>
        </Info>
      )}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          {!props.disablePrev && (
            <Button label={t('onboarding.main.backButton')} version={2} disabled={props.disablePrev} />
          )}
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            // @ts-ignore:next-line
            disabled={emptyValidation || (!formData?.passport?.value?.documentName && !formData?.drivingLicense?.value?.documentName && !formData?.nationalIdentityCard?.value?.documentName)}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default IndividualAccountOpeningDocumentationForm
